<template>
    <div style="width: 415px; overflow: auto; " ref="mainFeed">
        
        <div id="xButt" class="delete  top10" @click="$parent.closeRightBar"></div>
       
        <div style="position: fixed; width:405px; z-index: 2" class="">
            <div class="has-text-white is-size-4 has-background-dark pad10">
                <right-bar-switcher class="top-10"></right-bar-switcher>
                FEED
                 <div class="is-pulled-right is-size-7 top20 handCursor has-text-coolGreen" @click="toggleImages">
                    toggle images
                 </div>
            </div>
            
        </div>
       
      <br><br><br><br>
    
      <div v-if="cards.length == 0 && loaded">
          <div class="has-text-white pad10">You are not following any bundles.</div>
      </div>


       <div>
            <div v-for="(i, c) in consolidatedCards" :key="c" ref="posts">
                 <div class="has-background-grey has-text-left handCursor yellowBorderTitle" style="height: 30px" @click="goToProfile(i.handle)">
                    <div class="avatarTiny is-inline-block top2 left5">
                        <img :src="i.avatarImg" />
                    </div>
                    <div class="is-inline-block is-size-7 vTop top6 left3">
                        <b class="has-text-white">{{i.handle}}</b>
                    </div>
                    <div class="is-pulled-right right15 has-text-white is-size-8 top8 ">
                        <b><timeago :datetime="i.sortDate"></timeago></b>
                    </div>
                </div>

                <div class=" has-text-left handCursor is-inline-block has-text-white" @click="goToProfile(i.handle, i.mCode)">
                    <div class="is-inline-block  top5 left5 bundleEllipsis" style="padding-right: 5px; border-top-left-radius: 8px"><div class="is-inline-block has-text-coolGreen handCursor  ">&nbsp;<b>::</b></div>
                    <span class="is-size-6 has-text-white "><b> {{i.rootName}}</b></span></div>
                </div>
                <i v-if="i.rootId != i.id_BUNDLES" class="fas fa-arrow-right has-text-white left3  is-size-7 is-inline-block posRelative" style="top: -7px"></i>
                <div v-if="i.rootId != i.id_BUNDLES" class="subBundleLabel is-inline-block bundleEllipsis" @click="goToProfile(i.handle, i.mCode, i.id_BUNDLES)">
                    <div class="is-inline-block has-text-coolGreen ">&nbsp;<b>::</b></div><span class="has-text-white "> {{i.listName}}</span>
                </div>

                 <div class="is-inline-block is-pulled-right  right40 top5">
                        <button class="button is-small is-coolGreen xs" @click="imp(c)">IMPORT</button>
                    </div>
               <div class="is-inline-block" style="position: absolute; right: 10px">
                    <div v-if="i.collapsed" class="vAlignTop top5 right3 has-text-coolGreen  handCursor" @click="expandImg(c)">
                        <i class="fas fa-caret-right"></i>
                    </div>
    
                    <div v-if="!i.collapsed" class="vAlignTop top2  has-text-coolGreen left5 handCursor" @click="collapseImg(c)" >
                        <i class="fas fa-sort-down"></i>
                    </div>
               </div>

               <div v-if="i.otherBundles && i.otherBundles.length" class="top-10">
                        <div v-for="(o, oInd) in i.otherBundles" :key="oInd">
                            <div class=" has-text-left handCursor is-inline-block has-text-white" @click="goToProfile(i.handle, o.mCode)">
                                <div class="is-inline-block  top5 left5 bundleEllipsis" style="padding-right: 5px; border-top-left-radius: 8px"><div class="is-inline-block has-text-coolGreen handCursor" style="opacity: 0">&nbsp;<b>::</b></div>
                                <span class="is-size-6 has-text-white " style="opacity: 0"><b> {{o.rootName}}</b></span></div>
                             </div>
                             <i v-if="o.rootId != o.id_BUNDLES" class="fas fa-arrow-right has-text-white left3  is-size-7 is-inline-block posRelative" style="top: -7px"></i>
                            <div v-if="o.rootId != o.id_BUNDLES" class="subBundleLabel is-inline-block bundleEllipsis" @click="goToProfile(i.handle, o.mCode, o.id_BUNDLES)">
                                <div class="is-inline-block has-text-coolGreen ">&nbsp;<b>::</b></div><span class="has-text-white "> {{o.listName}}</span>
                            </div>
                        </div>
                    </div>
               
               <div>
                    <div class="left5 has-background-grey-dark top5" style="padding-top: 10px">
                        <card-shared class="noMarginLeft"  ref="c" v-bind:cardInfo="i" :inFeed="true" :collapsed="i.collapsed"></card-shared>
                    </div>
               </div>

               <div v-if="i.showUTD" >
                   <div class="has-background-coolGreen pad10 has-text-centered bottom5">
                       <b>You are up to date</b>
                   </div>
               </div>

            </div>
           
       </div>
        <div id="loader" style="z-index: 5" >

        </div>
    </div>
</template>


<script>
import CardShared from './CardShared'
import RightBarSwitcher from '../components/RightBarSwitcher'
export default{

    components: {CardShared, RightBarSwitcher},

    data: function(){
        return {
            cards: [],
            loaded: false,
            limit: 20,
            offset: 0,
            done: false,
            foundUTD: false,
            images: false,
            consolidatedCards: [],
            currId: 0,
            currE: 0
        }
    },

    mounted: function(){
      
        var self = this;

        var observer = new IntersectionObserver(function(entries) {
            // isIntersecting is true when element and viewport are overlapping
            // isIntersecting is false when element and viewport don't overlap
            if(entries[0].isIntersecting === true){
                observer.disconnect()
                self.getMore()
            }
               
        }, { threshold: [0] });

        

        function w(d){

            az.addRemSpinner(false, 'id', 'loader');

            self.cards = []
            self.$root.app.lastFeed = new Date(d.lastFeed)
            self.loaded = true
           

            d.cards.forEach((e, ite) => {

                let b = d.bundles.find(n => {
                    return n.id == e.id_BUNDLES
                })

                let r = d.roots.find(i => {
                    return i.id_BUNDLES == b.rootId
                })
                
                e.rootId = b.rootId
                e.rootName = b.rootName
                e.pubId = r.id_PUBBUNDLES
                e.handle = r.handle
                e.avatarImg = r.avatarImg
                e.profileId = r.id_PROFILES
                e.mCode = r.mCode
                e.collapsed = new Date(e.sortDate) < self.$root.app.lastFeed
                if(!e.collapsed){
                    self.images = true
                }

             /*    if(new Date(e.sortDate) > self.$root.app.lastFeed && !self.foundUTD){
                    e.showUTD = true;
                    self.foundUTD = true;
                } else {
            
                } */
                
                self.cards.push(e)
            
            })

            if(!self.foundUTD){
                for(var b = self.cards.length - 1; b > -1; b--){
                    if(new Date(self.cards[b].sortDate) > self.$root.app.lastFeed){
                        self.cards[b].showUTD = true
                        self.foundUTD = true
                        break
                    }
                }
            }

            //consolidate repeating cards
            
            self.cards.forEach(e => {
                if(e.id_CARDS != self.currId){
                    self.consolidatedCards.push(e)
                    self.currId = e.id_CARDS
                    self.currE++;
                } else {
                    if(self.consolidatedCards[self.currE - 1].otherBundles == undefined)
                        self.consolidatedCards[self.currE -1].otherBundles = []
                        self.consolidatedCards[self.currE -1].otherBundles.push(e)
                }
            })



            self.offset = self.offset + self.limit

            setTimeout(function(){
                observer.observe(self.$refs.posts[self.consolidatedCards.length - 1]);
            }, 10)
           

        }

        function n(){
            az.addRemSpinner(false, 'id', 'loader');
        }

        az.addRemSpinner(true, 'id', 'loader');
        this.$root.app.apiClient.get('subs/data/feed/' + this.limit + '/0', {}, w, n);
    },

    methods: {
        imp: function(c){
            this.$refs.c[c].openEdit()
        },

        goToProfile: function(p, mCode, deep){
            this.$router.push({name: 'profiledelegate', params: {propProfile: p, propMCode: mCode, deep: deep}})
        },

        scrolling: function(ev){
          
           /* if(ev.target.scrollTop >= ev.target.scrollHeight - ev.target.offsetHeight ){
                console.log('done')
           } */
        },

        getMore: function(){
            var self = this;

            if(this.done){
                return
            }

            function w(d){
                az.addRemSpinner(false, 'id', 'loader');
                 var observer = new IntersectionObserver(function(entries) {
                    // isIntersecting is true when element and viewport are overlapping
                    // isIntersecting is false when element and viewport don't overlap
                    if(entries[0].isIntersecting === true){
                        observer.disconnect()
                        self.getMore()
                    }
                    
                }, { threshold: [0] });

                if(d.cards.length == 0){
                    self.done = true
                }

                var tempArr = []
                d.cards.forEach((e, ite) => {

                    

                    let b = d.bundles.find(n => {
                        return n.id == e.id_BUNDLES
                    })

                    let r = d.roots.find(i => {
                        return i.id_BUNDLES == b.rootId
                    })
                    
                    e.rootId = b.rootId
                    e.rootName = b.rootName
                    e.pubId = r.id_PUBBUNDLES
                    e.handle = r.handle
                    e.avatarImg = r.avatarImg
                    e.profileId = r.id_PROFILES
                    e.mCode = r.mCode
/* 
                    if(new Date(e.cpCreateDate) > self.$root.app.lastFeed && !self.foundUTD){
                        e.showUTD = true;
                        self.foundUTD = true;
                    } else {
                
                    } */
                    
                    self.cards.push(e)
                    tempArr.push(e)

                })

                if(!self.foundUTD){
                    for(var b = self.cards.length - 1; b > -1; b--){
                        if(new Date(self.cards[b].sortDate) > self.$root.app.lastFeed){
                            self.cards[b].showUTD = true
                            self.foundUTD = true
                            break
                        }
                    }
                }

                self.offset = self.offset + self.limit

                tempArr.forEach(e => {
                    if(e.id_CARDS != self.currId){
                        self.consolidatedCards.push(e)
                        self.currId = e.id_CARDS
                        self.currE++;
                    } else {
                      
                        if(!self.consolidatedCards[self.currE-1].otherBundles)
                            self.consolidatedCards[self.currE-1].otherBundles = []
                        self.consolidatedCards[self.currE-1].otherBundles.push(e)
                    }
                })

                setTimeout(function(){
                    observer.observe(self.$refs.posts[self.consolidatedCards.length - 1]);
                }, 10)
            }

            function n(){
                az.addRemSpinner(false, 'id', 'loader');
            }

            az.addRemSpinner(true, 'id', 'loader');
            this.$root.app.apiClient.get('subs/data/feed/' + this.limit + '/' + this.offset, {}, w, n);
        },

        collapseImg: function(c){
            this.cards[c].collapsed = true;
        },

        expandImg: function(c){
            this.cards[c].collapsed = false;
        },

        toggleImages: function(){
            var self = this
            this.images = !this.images
            this.cards.forEach(e => {
                e.collapsed = !self.images
            })
        }

    
    }
     
}

</script>

<style scoped>
    #xButt{
        background-color: transparent !important;
        position: fixed;
        font-size: 2rem !important;
        right: 10px;
        z-index: 3
    }
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
</style>